import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

export default {
  state: () => ({
    selectedAdditionalServiceType: {},
  }),

  mutations: {
    setSelectedAdditionalServiceType(state, additionalServiceType) {
      Vue.set(state, "selectedAdditionalServiceType", additionalServiceType);
    },
  },
  actions: {
    //TODO: load, update, create
    createAdditionalServiceType: (context, request) => {
      //TODO: Loader start
      return axios
        .post(context.getters.getMcServiceUrl + "/additional-service-types/entity", request, {})
        .then((response) => {
          //TODO: Loader end
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadAdditionalServiceTypes: (context) => {
      //TODO: Loader start
      return axios.get(context.getters.getMcServiceUrl + "/additional-service-types/entity").then((response) => {
        return response.data;
      });
    },
    loadPublishedAdditionalServiceTypes: (context) => {
      //TODO: Loader start
      return axios.get(context.getters.getMcServiceUrl + "/additional-service-types/entity/published").then((response) => {
        //TODO: Loader koyulacak
        return response.data;
      });
    },
    loadAdditionalServiceType: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/additional-service-types/entity/" + request.id).then((response) => {
        return response.data;
      });
    },
    loadAdditionalServiceTypeHistory: (context, request) => {
      //TODO: Loader start
      return axios.post(context.getters.getMcServiceUrl + "/additional-service-types/entity/history/search", request, {}).then((response) => {
        //TODO: Loader end
        return response.data;
      });
    },
    loadSelectedAdditionalServiceTypeHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/additional-service-types/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },
    deleteAdditionalServiceType: (context, additionalServiceType) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/additional-service-types/entity/" + additionalServiceType.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          additionalServiceType.intents = intents;
          additionalServiceType.intentId = response.data.id;
          return additionalServiceType;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftAdditionalServiceType: (context, additionalServiceType) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/additional-service-types/draft/" + additionalServiceType.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    publishAdditionalServiceType: (context, additionalServiceType) => {
      return axios.get(context.getters.getMcServiceUrl + "/additional-service-types/publish/" + additionalServiceType.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },
    rejectAdditionalServiceType: (context, additionalServiceType) => {
      return axios.get(context.getters.getMcServiceUrl + "/additional-service-types/reject/" + additionalServiceType.intentId).then((response) => {
        if (additionalServiceType.intents[0].type === "DELETE_ADDITIONAL_SERVICE_TYPE") {
          additionalServiceType.intents = null;
          additionalServiceType.intentId = 0;
        } else if (additionalServiceType.intents[0].type === "CREATE_ADDITIONAL_SERVICE_TYPE") {
          additionalServiceType.intents[0].status = "DRAFT";
        } else if (additionalServiceType.intents[0].type === "UPDATE_ADDITIONAL_SERVICE_TYPE") {
          additionalServiceType.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },
    sendToApprovalAdditionalServiceType: (context, additionalServiceType) => {
      return axios.get(context.getters.getMcServiceUrl + "/additional-service-types/sendToApproval/" + additionalServiceType.intentId).then((response) => {
        if (additionalServiceType.intents[0].type === "CREATE_ADDITIONAL_SERVICE_TYPE") {
          additionalServiceType.intents[0].status = "WAITING_APPROVAL";
        } else if (additionalServiceType.intents[0].type === "UPDATE_ADDITIONAL_SERVICE_TYPE") {
          additionalServiceType.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    recallAdditionalServiceType: (context, additionalServiceType) => {
      return axios.get(context.getters.getMcServiceUrl + "/additional-service-types/recall/" + additionalServiceType.intentId).then((response) => {
        helper.recallOrRejectEntity(additionalServiceType, "ADDITIONAL_SERVICE_TYPE");
        return response.data;
      });
    },

    cancelAdditionalServiceType: (context, additionalServiceType) => {
      return axios.get(context.getters.getMcServiceUrl + "/additional-service-types/cancel/" + additionalServiceType.intentId).then((response) => {
        return response.data;
      });
    },
  },
  getters: {
    getSelectedAdditionalServiceType: (state) => {
      return state.selectedAdditionalServiceType;
    },
  },
};
